import { Locale } from './config';
import highIntentMessages from './highIntentMessages';
import { LocaleBundle } from './types';

const localeLoaders: Record<Locale, () => Promise<{ default: LocaleBundle }>> =
    {
        en: () => import('./locales/en'),
        ru: () => import('./locales/ru'),
        es: () => import('./locales/es'),
        fil: () => import('./locales/fil'),
        pt: () => import('./locales/pt'),
        id: () => import('./locales/id'),
        ja: () => import('./locales/ja'),
        th: () => import('./locales/th'),
        tr: () => import('./locales/tr'),
        ar: () => import('./locales/ar'),
        fr: () => import('./locales/fr'),
        de: () => import('./locales/de'),
        it: () => import('./locales/it'),
        pl: () => import('./locales/pl'),
        vi: () => import('./locales/vi'),
    };

const localeBundleCache = new Map<Locale, Promise<LocaleBundle>>();

export function loadLocaleBundle(locale: Locale): Promise<LocaleBundle> {
    const cached = localeBundleCache.get(locale);
    if (cached) {
        return cached;
    }

    const loader = localeLoaders[locale];
    const promise = loader().then((module) => ({
        ...module.default,
        messages: {
            ...module.default.messages,
            ...(highIntentMessages[locale] ?? {}),
        },
    }));
    localeBundleCache.set(locale, promise);
    return promise;
}
